module.exports = __webpack_public_path__ + "static/media/bluearrow.03f86249.svg";